import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { DsBadgeComponent } from '@design-system/ds-badge/component/ds-badge.component';
import { DsTextComponent } from '@design-system/ds-text/component/ds-text.component';
import { mapIbRepoStatusPill } from '../../../helpers/map-ib-repo-status-pill.helper';
import { IbRepoStatusPillInterface } from '../../../interfaces/ib-repo-status-pill.interface';
import { IbRepoVerificationStateInterface } from '../../../interfaces/ib-repo-verification-state.interface';

/**
 * Shows the IB repo verification status under the IB repo leg.
 * For a user with the verify role the status badge is a button that opens the verification panel.
 */
@Component({
  selector: 'app-btr-ib-repo-status',
  templateUrl: './btr-ib-repo-status.component.html',
  styleUrls: ['./btr-ib-repo-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, DsBadgeComponent, DsTextComponent],
})
export class BtrIbRepoStatusComponent implements OnChanges {
  @Input() state: IbRepoVerificationStateInterface | null = null;
  @Input() canVerify = false;
  @Input() isPanelOpen = false;
  @Output() readonly openPanel = new EventEmitter<void>();

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  pill: IbRepoStatusPillInterface | null = null;

  ngOnChanges(): void {
    this.pill = mapIbRepoStatusPill(this.state, this.canVerify, this.isPanelOpen);
  }

  /** Moves the focus back to the status badge button, for example after the panel closes. */
  focus(): void {
    this.host.nativeElement.querySelector<HTMLButtonElement>('.btr-ib-status__pill')?.focus();
  }
}
